import React from 'react'
import { Link } from 'react-router-dom'
import shop_1 from '../../../assets/images/shop/product-1.png'
import shop_2 from '../../../assets/images/shop/product-2.png'
import shop_3 from '../../../assets/images/shop/product-3.png'
import shop_4 from '../../../assets/images/shop/product-4.png'
import shop_5 from '../../../assets/images/shop/product-5.png'
import shop_6 from '../../../assets/images/shop/product-6.png'
import shop_7 from '../../../assets/images/shop/product-7.png'
import shop_8 from '../../../assets/images/shop/product-8.png'
import shop_9 from '../../../assets/images/svg/header/Search.svg'
import shop_10 from '../../../assets/images/shop/product-9.jpg'
import shop_11 from '../../../assets/images/shop/product-10.jpg'
import shop_12 from '../../../assets/images/shop/product-11.jpg'
import shop_13 from '../../../assets/images/shop/product-12.jpg'

const Shop = () => {
    return (
        <>
            <>
                <div className="shop-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8 col-lg-7">
                                <div className="shop-fillter">
                                    <p>Showing 1–8 of 11 results</p>
                                    <form action="#">
                                        <select name="fillter" className="fillter-option">
                                            <option>Default sorting</option>
                                            <option value="popularity">popularity</option>
                                            <option value="average">average rating</option>
                                            <option value="low">price: low to high</option>
                                            <option value="high">price: high to low</option>
                                            <option value="latest">latest</option>
                                        </select>
                                    </form>
                                </div>
                                <div className="row gutter-x-15 gutter-y-60">
                                    <div className="col-xl-6">
                                        <div
                                            className="product-box animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="200ms"
                                        >
                                            <div className="product-image">
                                                <img
                                                    src={shop_1}
                                                    alt="product-image"
                                                />
                                                <ul className="cart-icon">
                                                    <li>
                                                        <Link to="/ProdectDetails">
                                                            <i className="fa-solid fa-cart-shopping" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Cart">
                                                            <i className="fa-solid fa-heart" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="product-details">
                                                <h4>
                                                    <Link to="/ProdectDetails">White Bottle</Link>
                                                </h4>
                                                <p>$120.00</p>
                                                <ul className="product-retting">
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div
                                            className="product-box animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="400ms"
                                        >
                                            <div className="product-image">
                                                <img
                                                    src={shop_2}
                                                    alt="product-image"
                                                />
                                                <Link to="/ProdectDetails" className="offer">
                                                    Sale
                                                </Link>
                                                <ul className="cart-icon">
                                                    <li>
                                                        <Link to="/ProdectDetails">
                                                            <i className="fa-solid fa-cart-shopping" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Cart">
                                                            <i className="fa-solid fa-heart" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="product-details">
                                                <h4>
                                                    <Link to="/ProdectDetails">Amazon Portable Speaker</Link>
                                                </h4>
                                                <p>$120.00</p>
                                                <ul className="product-retting">
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-regular fa-star" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div
                                            className="product-box animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="600ms"
                                        >
                                            <div className="product-image">
                                                <img
                                                    src={shop_3}
                                                    alt="product-image"
                                                />
                                                <Link href="/ProdectDetails" className="offer">
                                                    Sale
                                                </Link>
                                                <ul className="cart-icon">
                                                    <li>
                                                        <Link to="/ProdectDetails">
                                                            <i className="fa-solid fa-cart-shopping" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Cart">
                                                            <i className="fa-solid fa-heart" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="product-details">
                                                <h4>
                                                    <Link to="/ProdectDetails">Mango Handbag</Link>
                                                </h4>
                                                <p>$120.00</p>
                                                <ul className="product-retting">
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-regular fa-star" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div
                                            className="product-box animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="800ms"
                                        >
                                            <div className="product-image">
                                                <img
                                                    src={shop_4}
                                                    alt="product-image"
                                                />
                                                <ul className="cart-icon">
                                                    <li>
                                                        <Link to="ProdectDetails">
                                                            <i className="fa-solid fa-cart-shopping" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Cart">
                                                            <i className="fa-solid fa-heart" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="product-details">
                                                <h4>
                                                    <Link to="/ProdectDetails">Amazon Portable Speaker</Link>
                                                </h4>
                                                <p>$120.00</p>
                                                <ul className="product-retting">
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div
                                            className="product-box animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="1000ms"
                                        >
                                            <div className="product-image">
                                                <img
                                                    src={shop_5}
                                                    alt="product-image"
                                                />
                                                <ul className="cart-icon">
                                                    <li>
                                                        <Link to="/ProdectDetails">
                                                            <i className="fa-solid fa-cart-shopping" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Cart">
                                                            <i className="fa-solid fa-heart" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="product-details">
                                                <h4>
                                                    <Link to="/ProdectDetails">Slim Smart Watch</Link>
                                                </h4>
                                                <p>$120.00</p>
                                                <ul className="product-retting">
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div
                                            className="product-box animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="1200ms"
                                        >
                                            <div className="product-image">
                                                <img
                                                    src={shop_6}
                                                    alt="product-image"
                                                />
                                                <Link to="/ProdectDetails" className="offer">
                                                    Sale
                                                </Link>
                                                <ul className="cart-icon">
                                                    <li>
                                                        <Link to="/ProdectDetails">
                                                            <i className="fa-solid fa-cart-shopping" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Cart">
                                                            <i className="fa-solid fa-heart" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="product-details">
                                                <h4>
                                                    <Link to="/ProdectDetails">Gloving T-shirt</Link>
                                                </h4>
                                                <p>$120.00</p>
                                                <ul className="product-retting">
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-regular fa-star" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div
                                            className="product-box animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="1600ms"
                                        >
                                            <div className="product-image">
                                                <img
                                                    src={shop_7}
                                                    alt="product-image"
                                                />
                                                <ul className="cart-icon">
                                                    <li>
                                                        <Link to="/ProdectDetails">
                                                            <i className="fa-solid fa-cart-shopping" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Cart">
                                                            <i className="fa-solid fa-heart" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="product-details">
                                                <h4>
                                                    <Link to="/ProdectDetails">Earpad Special</Link>
                                                </h4>
                                                <p>$120.00</p>
                                                <ul className="product-retting">
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-regular fa-star" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div
                                            className="product-box animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="1800ms"
                                        >
                                            <div className="product-image">
                                                <img
                                                    src={shop_8}
                                                    alt="product-image"
                                                />
                                                <ul className="cart-icon">
                                                    <li>
                                                        <Link to="/ProdectDetails">
                                                            <i className="fa-solid fa-cart-shopping" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Cart">
                                                            <i className="fa-solid fa-heart" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="product-details">
                                                <h4>
                                                    <Link to="/ProdectDetails">Coffee Mug</Link>
                                                </h4>
                                                <p>$120.00</p>
                                                <ul className="product-retting">
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-star" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="pagination">
                                            <div className="blog-pagination-btn active">
                                                <Link href="#">1</Link>
                                            </div>
                                            <div className="blog-pagination-btn">
                                                <Link href="#">2</Link>
                                            </div>
                                            <div className="blog-pagination-btn">
                                                <Link href="#">
                                                    <i className="fa-solid fa-chevron-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-5">
                                <div className="shop-sidebar">
                                    <div
                                        className="shop-widget animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="200ms"
                                    >
                                        <div className="shop-search-widget">
                                            <form action="#">
                                                <input
                                                    type="search"
                                                    name="search"
                                                    placeholder="Search Here ..."
                                                />
                                                <button type="submit">
                                                    <img src={shop_9} alt="icon" />
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <div
                                        className="shop-widget animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="400ms"
                                    >
                                        <div className="product-category-widget">
                                            <h4>Product categories</h4>
                                            <ul>
                                                <li>
                                                    <Link to="#">Business Consulting</Link>
                                                    <span>3</span>
                                                </li>
                                                <li>
                                                    <Link to="#">Corporate</Link>
                                                    <span>1</span>
                                                </li>
                                                <li>
                                                    <Link to="#">IT Solutions</Link>
                                                    <span>2</span>
                                                </li>
                                                <li>
                                                    <Link to="#">Marketing</Link>
                                                    <span>4</span>
                                                </li>
                                                <li>
                                                    <Link to="#">Startuo Consulting</Link>
                                                    <span>5</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div
                                        className="shop-widget animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="600ms"
                                    >
                                        <div className="fillter-widget">
                                            <h4>Filter by pricing</h4>
                                            <span id="fillter-rang" className="fillter-price-rang">
                                                <span
                                                    id="fillter-rang-handle"
                                                    className="fillter-price-rang-handle"
                                                />
                                            </span>
                                            <div className="fillter-price-box">
                                                <span className="fillter-price-rang-inner">
                                                    <span id="current-price">$50</span> -
                                                    <span id="max-price" />
                                                </span>
                                                <Link to="/Shop" className="btn btn-primary btn-theme">
                                                    Filter
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="shop-widget animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="800ms"
                                    >
                                        <div className="product-widget">
                                            <h4>Products</h4>
                                            <div className="product-list">
                                                <img
                                                    src={shop_10}
                                                    alt="product-image"
                                                />
                                                <div className="title">
                                                    <Link to="/ProdectDetails">Thermal Water Tank</Link>
                                                    <p>$12.00</p>
                                                </div>
                                            </div>
                                            <div className="product-list">
                                                <img
                                                    src={shop_11}
                                                    alt="product-image"
                                                />
                                                <div className="title">
                                                    <Link href="/ProdectDetails">Samsung Watch</Link>
                                                    <p>$30.00</p>
                                                </div>
                                            </div>
                                            <div className="product-list">
                                                <img
                                                    src={shop_12}
                                                    alt="product-image"
                                                />
                                                <div className="title">
                                                    <Link href="/ProdectDetails">Amazon Portable Speaker</Link>
                                                    <p>$10.00</p>
                                                </div>
                                            </div>
                                            <div className="product-list">
                                                <img
                                                    src={shop_13}
                                                    alt="product-image"
                                                />
                                                <div className="title">
                                                    <Link href="/ProdectDetails">Thermal Specker</Link>
                                                    <p>$60.00</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="shop-widget animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="1000ms"
                                    >
                                        <div className="tag-widget">
                                            <h4>Our Tags</h4>
                                            <ul>
                                                <li>
                                                    <Link to="#">marketing</Link>
                                                </li>
                                                <li>
                                                    <Link to="#">Business</Link>
                                                </li>
                                                <li>
                                                    <Link to="#">Consulting</Link>
                                                </li>
                                                <li>
                                                    <Link to="#">Finance</Link>
                                                </li>
                                                <li>
                                                    <Link to="#">Bank</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>

        </>
    )
}

export default Shop
